import React, { useEffect, useState } from 'react'
import axios from "axios";
import { useLocation } from 'react-router-dom';
import { UserTokenURL } from '../../../services/ApiHIS';
import { postFirmaMedico } from '../../../services/Clinico';
import Loading from '../../Loading';
import ModalFirmarDocumento from './ModalFirmarDocumento';
import ModalSubirImagenFirmaMedico from './ModalSubirImagenFirmaMedico';

const FirmaMedicoPrincipal = () => {
    const [dataMedico, setdataMedico]=useState([])
    const [loading, setloading]=useState(true)
    const [idMedico, setidMedico]=useState('')
    const [modalOnFirmarMedico, setmodalOnFirmarMedico]=useState(false)
    const [informacionMedico, setinformacionMedico]=useState('')
    const [actualizarData, setactualizarData]=useState('')
    const [modalOnSubirFirma, setmodalOnSubirFirma]=useState(false)

    //token
    let query = new URLSearchParams(useLocation().search);
    let tokenCons = JSON.parse(query.get('token'));
    let location = useLocation();
    //localStorage.removeItem('tokenReact');
    //localStorage.setItem('tokenReact',tokenCons)
    useEffect(() => { 
        // Google Analytics
        localStorage.removeItem('tokenReact');
        localStorage.setItem('tokenReact',tokenCons)
    }, [location]);

     //token
    useEffect(()=>{
    
        //console.log(tokenCons,'tokenConstokenCons')
        const url = UserTokenURL()
    
        // Configurar la cabecera con el token JWT
        const headers = {
        Authorization: `Bearer ${tokenCons}`,
        };
    

        // Realiza la petición con Axios
        axios.get(url, { headers })
        .then(response => {
        //console.log(response, 'data user');

        // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
        localStorage.removeItem('usuarioInfo');
        //console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
        // Guarda los nuevos datos
        localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));

        

        
        })
        .catch(error => {
        console.error('Error al autenticar al usuario:', error);
        //seterrorEndpoint(true)
        });
    },[])

    useEffect(()=>{
        const buscarIdMedico={
            'MMCedM': idMedico            
        }
        setloading(false)
        postFirmaMedico(buscarIdMedico).then((res)=>{
            setloading(true)
            console.log(res.data,' firma medicos')
            setdataMedico(res.data.data)
        })
    },[actualizarData])

    const handleOnSubmitBuscar=(e)=>{
        e.preventDefault()
        setidMedico(e.target.userId.value)
        const buscarIdMedico={
            'MMCedM': e.target.userId.value
        }
        setloading(false)
        postFirmaMedico(buscarIdMedico).then((res)=>{
            setloading(true)
            console.log(res.data,' firma medicos')
            setdataMedico(res.data.data)
        })
    }

    const handleOnClickFirmaMedico=(item)=>{
        setinformacionMedico(item)
        setmodalOnFirmarMedico(true)
    }

    const handleOnClickSubirFirma=(item)=>{
      setinformacionMedico(item)
      setmodalOnSubirFirma(true)
    }
  return (
    <>
      <div className="">
        <div className=" text-2xl text-[#05a29d] font-medium pb-3">
          Firma Médico
        </div>
        <form onSubmit={handleOnSubmitBuscar}>
          <div className="flex ">
            <div className="mb-3 xl:w-96">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                N° documento identidad
              </label>
              <div className="flex">
                <input
                  name="userId"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-sm font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
                <div className="px-3">
                  <button
                    type="submit"
                    className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Buscar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>        
        <div className="flex flex-col">
            <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
                <div className="py-2 inline-block min-w-full">
                <div className="overflow-auto md:overflow-visible">
                    <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>
                    <th></th>
                      
                      
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900  py-2 "
                      >
                        
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900  py-2 "
                      >
                        
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900  py-2 "
                      >
                        Firmo?
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Documento
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Nombre
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Codigo
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading?
                    dataMedico.map((item, index) => (
                      <tr className='divide-y divide-slate-700' key={index}>
                        <td></td>
                        <td className="text-xs text-gray-900 font-medium px-1 py-2 whitespace-pre-wrap">
                            <button
                            onClick={()=>handleOnClickFirmaMedico(item)}
                            //disabled={false}
                            type="button"
                            className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                            >Escribir Firma
                            </button>
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-1 py-2 whitespace-pre-wrap">
                        <button
                          onClick={() => handleOnClickSubirFirma(item)}
                          type="button"
                          className="inline-flex items-center px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="mr-2 text-white"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M10 9h-6l8-9 8 9h-6v11h-4v-11zm11 11v2h-18v-2h-2v4h22v-4h-2z" />
                          </svg>
                          Subir Imagen Firma
                        </button>
                        </td>
                        <td className="text-xs text-gray-900 font-medium whitespace-pre-wrap text-center align-middle h-full">
                                  {item.MMFIRMA? (
                                    <div className="flex justify-center items-center h-full">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 100 100"
                                        width="25"
                                        height="25"
                                      >
                                        {/* Círculo de fondo */}
                                        <circle cx="50" cy="50" r="50" fill="#4caf50" />
                                        {/* Línea de verificación */}
                                        <polyline
                                          points="30,50 45,65 70,40"
                                          fill="none"
                                          stroke="#fff"
                                          strokeWidth="8"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </div>
                                  ) : (
                                    <div className="flex justify-center items-center h-full">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 100 100"
                                        width="25"
                                        height="25"
                                      >
                                        <circle cx="50" cy="50" r="50" fill="#ff7043" />
                                        <line
                                          x1="35"
                                          y1="35"
                                          x2="65"
                                          y2="65"
                                          stroke="#fff"
                                          strokeWidth="8"
                                          strokeLinecap="round"
                                        />
                                        <line
                                          x1="65"
                                          y1="35"
                                          x2="35"
                                          y2="65"
                                          stroke="#fff"
                                          strokeWidth="8"
                                          strokeLinecap="round"
                                        />
                                      </svg>
                                    </div>
                                  )}
                                </td>
                        <td className="text-xs text-gray-900 font-medium px-1 py-2 whitespace-pre-wrap">
                            {item.MMCedM}
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-1 py-2 whitespace-pre-wrap text-left">
                            {item.MMNomM}
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-1 py-2 whitespace-pre-wrap">
                            {item.MMCODM}
                        </td>
                        
                      </tr>
                    )):                    
                    <tr className="divide-y divide-slate-700 ">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td><Loading/></td>
                      <td></td>
                      <td></td>
                    </tr>
                    
                  }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> 
      </div>
      {modalOnFirmarMedico && <ModalFirmarDocumento setmodalOnFirmarMedico={setmodalOnFirmarMedico} informacionMedico={informacionMedico} setactualizarData={setactualizarData}/>}
      {modalOnSubirFirma && <ModalSubirImagenFirmaMedico setmodalOnSubirFirma={setmodalOnSubirFirma} informacionMedico={informacionMedico} setactualizarData={setactualizarData}/>}
    </>
  )
}

export default FirmaMedicoPrincipal